module Meevo.Components.Common {
    import ClientMembershipIndicatorEnum = Meevo.Model.ClientMembershipIndicatorEnum;

    export enum MembershipDetailsPart {
        ClassName,
        IconFileName,
        DisplayName
    }

    export class MembershipDetailsService {
        constructor(private $translate) {
        }

        getDetails(membership, part: MembershipDetailsPart): string {
            if (!membership) {
                return "";
            }

            const getReturnStr = (className, iconFilename, contentKey) => {
                switch (part) {
                    case MembershipDetailsPart.ClassName:
                        return className;
                    case MembershipDetailsPart.IconFileName:
                        return "assets/images/icons/" + iconFilename;
                    case MembershipDetailsPart.DisplayName:
                        return membership.membershipDisplayName + " - " + this.$translate.instant(contentKey);
                }
                return null;
            }

            switch (membership.membershipIndicatorStatus || membership.clientMembershipIndicatorStatusEnum) {
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.WithinInitialTerm:
                    return getReturnStr("client-withinInitialTerm", "membership_original.svg", "LABEL_TOOLTIP_MEMBERSHIP_WITHININITIALTERM");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation:
                    return getReturnStr("client-cancelledMembership", "membership_futuretermdate.svg", "LABEL_TOOLTIP_MEMBERSHIP_INCANCELLATION");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.Frozen:
                    if (membership.clientMembershipIndicatorEnum === ClientMembershipIndicatorEnum.BlueStarWithPauseAndPlus) {
                        return getReturnStr("client-frozenMembership", "membership_frozen_plus.svg", "LABEL_TOOLTIP_MEMBERSHIP_FROZEN");
                    } else {
                        return getReturnStr("client-frozenMembership", "membership_frozen.svg", "LABEL_TOOLTIP_MEMBERSHIP_FROZEN");
                    }
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.CCDueToExpire:
                    return getReturnStr("client-creditCardExpiring", "membership_ccexpiring.svg", "LABEL_TOOLTIP_MEMBERSHIP_CCDUETOEXPIRE");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.Initial90:
                    return getReturnStr("client-initial90", "membership_first90days.svg", "LABEL_TOOLTIP_MEMBERSHIP_INITIAL90");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.SoldToday:
                    return getReturnStr("client-soldToday", "membership_firstday.svg", "LABEL_TOOLTIP_MEMBERSHIP_SOLDTODAY");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.NonCounting:
                    return getReturnStr("client-nonCounting", "membership_noncounting.svg", "LABEL_TOOLTIP_MEMBERSHIP_NONCOUNTING");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.DueToExpire:
                    return getReturnStr("client-dueToExpire", "membership_expire30days.svg", "LABEL_TOOLTIP_MEMBERSHIP_DUETOEXPIRE");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.InRenewal:
                    return getReturnStr("client-inRenewal", "membership_renewpastterm.svg", "LABEL_TOOLTIP_MEMBERSHIP_INRENEWAL");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.Expired: {

                    const status = membership.membershipStatus || membership.clientMembershipStatusEnum;
                    // if cancelled don't display any icon
                    if ( status == Meevo.Model.ClientMembershipStatusEnum.Cancelled) {
                        return "";
                    }

                    return getReturnStr("client-expired", "membership_expired.svg", "LABEL_TOOLTIP_MEMBERSHIP_EXPIRED");
                }
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.Suspended:
                    return getReturnStr("client-suspended", "membership_suspended.svg", "LABEL_TOOLTIP_MEMBERSHIP_SUSPENDED");
                case Meevo.Model.ClientMembershipIndicatorStatusEnum.Error:
                    return getReturnStr("client-error", "membership_pmtdidnotprocess.svg", "LABEL_TOOLTIP_MEMBERSHIP_ERROR");
            }

            return "";
        }

        static factory(): Function {
            let svc = ($translate) => {
                return new MembershipDetailsService($translate);
            }

            svc.$inject = ["$translate"];

            return svc;
        }
    }
    angular.module("meevo.components.common")
        .factory("meevo.components.common.MembershipDetailsService", MembershipDetailsService.factory());
}
